import { Skeleton } from "@/components/ui/skeleton";

function AboutCardSkeleton({ index }: { index: number }) {
  return (
    <div
      key={index}
      className="w-full bg-white h-[28rem] relative rounded-xl overflow-hidden shadow-lg flex flex-col"
    >
      <Skeleton className="w-full h-[14rem]" />
      <div className="px-4 w-full py-3 h-[14rem] bg-gray-900 bg-opacity-50">
        <Skeleton className="h-6 w-3/4 mb-2" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        <Skeleton className="h-10 w-full mt-3 rounded-full" />
      </div>
    </div>
  );
}

export default AboutCardSkeleton;
